import type { TFuncKey } from 'i18next';
import { useTranslation } from 'react-i18next';

type Props = {
  readonly phrase: TFuncKey;
  readonly address: string;
  readonly target: string;
};

// A private-use character no translation contains, so the target's position survives any word order.
const marker = '';

/** The code-sent sentence with the email or phone it went to set apart, so a typo is easy to spot. */
const EmphasizedTarget = ({ phrase, address, target }: Props) => {
  const { t } = useTranslation();
  const [before = '', after = ''] = String(t(phrase, { address, target: marker })).split(marker);

  return (
    <>
      {before}
      <bdi className="font-medium text-foreground">{target}</bdi>
      {after}
    </>
  );
};

export default EmphasizedTarget;
